// Path: ./src/app/components/DatePickerMui/index.tsx
import { useState, useEffect } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import dayjs, { Dayjs } from "dayjs";
import { Wrapper, Text } from "./styled";

declare module "@mui/material/styles" {
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}

interface Props {
  text?: string;
  defaultDate?: Date;
  minDate?: Date;
  onChange?: (value: Date) => void;
  textCss?: string;
  dateInputPadding?: number;
  dataTestId?: string;
  disabled?: boolean;
}

export function DatePickerMui({
  text,
  onChange,
  defaultDate,
  minDate,
  textCss,
  dateInputPadding,
  dataTestId,
  disabled = false,
}: Props) {
  const theme = createTheme({
    palette: {
      background: {
        default: "#fd954f",
      },
      primary: {
        main: "#fd954f",
      },
      text: {
        primary: "#000000",
      },
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            padding: dateInputPadding ?? 10,
          },
        },
      },
    },
  });

  const [value, setValue] = useState<Dayjs | null>(
    defaultDate ? dayjs(defaultDate) : null
  );

  useEffect(() => {
    if (defaultDate) {
      setValue(dayjs(defaultDate));
    }
  }, [defaultDate]);

  const handleDateChange = (newValue: Dayjs | null) => {
    setValue(newValue);
    if (newValue && onChange) {
      onChange(newValue.toDate());
    }
  };

  return (
    <Wrapper data-testid="datepickermui-test-id">
      {text && <Text textCss={textCss}>{text}</Text>}
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={value}
            minDate={minDate ? dayjs(minDate) : undefined}
            onChange={handleDateChange}
            data-testid={dataTestId}
            className={dataTestId}
            disabled={disabled}
          />
        </LocalizationProvider>
      </ThemeProvider>
    </Wrapper>
  );
}
